import React from 'react';
import { useRecoilValue } from 'recoil';
import { environmentContextState } from '../../recoil/atoms';
import { LeadGenerationForm } from '../../root/components/LeadGenerationForm';
import { SelectionType } from '../../enums/SelectionType.enum';
import { Icon } from '../../icons/Icon';
import { useSetModalState } from '../../hooks/actions/useModalState';
import { ModalToggleState } from '../../models/actionStates';
import { useProductSelection } from '../../hooks/useProductSelection';
import { ViewVariant } from '../../models/ShopifyVariant.model';
import { ViewProduct } from '../../models/ViewProduct.model';
import styles from './KlaviyoBackInStockNotificationModal.module.scss';
import { Button, ButtonBaseProps } from '../../root/components/buttons/Button';

interface Props extends Omit<ButtonBaseProps, 'text'> {
  selectionType: SelectionType;
  selectionKey: string;
}

interface ModalProps {
  variant: ViewVariant;
  product: ViewProduct;
}

const KlaviyoModal: React.FC<ModalProps> = ({ variant, product }) => {
  const setModal = useSetModalState();
  const [showSuccess, setShowSuccess] = React.useState<boolean>(false);
  const environmentContext = useRecoilValue(environmentContextState);

  return (
    <div className={styles.modalWrapper}>
      <div className={styles.modalHeader}>
        <button className={styles.hlModalCloseIcon} onClick={() => setModal({ toggleState: ModalToggleState.Closed })}>
          <Icon name="close" style={{ width: '12px' }} />
        </button>
      </div>
      <div className={styles.content}>
        <span className={styles.title}>{variant?.name ?? ''}</span>
        {!showSuccess && (
          <React.Fragment>
            <div className={styles.copy}>Register to receive a notification when this item comes back in stock.</div>
            <LeadGenerationForm
              klaviyoFormKeys={environmentContext.klaviyo.backInStockForm}
              buttonMessage={
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                  <span style={{ fontWeight: 500 }}>GET NOTIFIED</span>
                  <span style={{ fontWeight: 300, textTransform: 'none' }}>when back in stock</span>
                </div>
              }
              successAction={() => setShowSuccess(true)}
              isBackInStockSubscription={true}
              productId={product.id}
              variantId={variant?.id ?? ''}
              textboxStyle={{ marginBottom: 15 }}
            />
          </React.Fragment>
        )}
        {showSuccess && (
          <div>
            <span>We&apos;ll let you know when it&apos;s available!</span>
            <Button buttonType={'transparent'} onClick={() => setModal({ toggleState: ModalToggleState.Closed })} text="Continue shopping" />
          </div>
        )}
      </div>
    </div>
  );
};

export const KlaviyoBackInStockNotificationModal: React.FC<Props> = ({ selectionType, selectionKey, buttonType, size }) => {
  const setModal = useSetModalState();
  const { variant, product } = useProductSelection(selectionType, selectionKey);

  return (
    <React.Fragment>
      <Button
        onClick={(event) => {
          event.preventDefault();
          variant &&
            setModal({
              contents: <KlaviyoModal variant={variant} product={product} />,
              height: 400,
              width: 500,
              maxWidth: '100vw',
              maxHeight: 'unset',
              toggleState: ModalToggleState.Open,
              scrollToTop: false,
              isBaseState: true,
            });
        }}
        fullWidth={true}
        text={'Join waitlist'}
        subText={'Sold out'}
        buttonType={buttonType}
        size={size}
      />
    </React.Fragment>
  );
};

export default KlaviyoBackInStockNotificationModal;
